import React, { useState } from 'react';

import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Checkbox } from "@progress/kendo-react-inputs";
import { Dialog } from '@progress/kendo-react-dialogs';

import SvgIcon from '../../CustomeComponents/SvgIcon';

const ChavatDaatDialog = ({ chavatDaat, closeDialog }) => {
    return (
        <Dialog title="חוות דעת" onClose={closeDialog} width={1000} height={500} style={{ overflow: 'hidden' }}>
            <p
                style={{
                    margin: "30px",
                    textAlign: "center"
                }}
            >
                <div  style={{ textAlign: "right", fontSize: "20px" }} dangerouslySetInnerHTML={{ __html: chavatDaat }} />
            </p>
        </Dialog>
    )
}

const CustomeTnaimPanelAndTable = ({ tnaiTitle, tnaiDataList, isExpend }) => {

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dialogData, setDialogData] = useState({});
    const titles = {
        "tnaiSugDescription": "תהליך",
        "teurTnai": "תאור תנאי",
        "buza": "בוצע",
        "taarihBizua": "תאריך ביצוע",
        "chavatDaatAnswer": "חוות דעת",
        "chavatDaatAnswerDetails": "פירוט",
        "taarihIdkun": "תאריך עדכון"
    }

    const LabeledDataItem = (label, value, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
            {
                field === "buza" ?
                    <Checkbox value={value ? true : false}/>
                    :
                    field === "chavatDaatAnswerDetails" ? 
                        ""
                        :
                        <div className="value">{value}</div>
            }
		</div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.field)}
		</td>
	}

    const SvgIconCell = (props) => {
        const data = props.dataItem;
        return <td {...props.tdProps} className="icon-cell">
            {
                data.chavatDaatAnswerDetails ?
                    LabeledDataItem('קישור', <SvgIcon icon={"eye"} style={{ cursor: 'pointer' }} onClick={() => toggleDialog(data.chavatDaatAnswerDetails)} />)
                    :
                    "-"
            }
        </td>
    }

    const toggleDialog = (chavatDaatDetails) => {
        setDialogData(chavatDaatDetails);
        setIsDialogOpen(!isDialogOpen);
	}

    return (
        <div>
            {/* <PanelBar>
                <PanelBarItem title={tnaiTitle} expanded={isExpend === 0 ? true : false}> */}
                    <Grid data={tnaiDataList} >
                        <GridColumn field="teurTnai" title={titles.teurTnai} cell={LabeledCell} />
                        <GridColumn field="buza" title={titles.buza} cell={LabeledCell} />
                        <GridColumn field="taarihBizua" title={titles.taarihBizua} cell={LabeledCell} />
                        <GridColumn field="chavatDaatAnswer" title={titles.chavatDaatAnswer} cell={LabeledCell} />
                        <GridColumn field="chavatDaatAnswerDetails" title={titles.chavatDaatAnswerDetails} cell={SvgIconCell} headerClassName={'icon-header-cell'} />
                        <GridColumn field="taarihIdkun" title={titles.taarihIdkun} cell={LabeledCell} />
                    </Grid>
                {/* </PanelBarItem>
            </PanelBar> */}

            {isDialogOpen && <ChavatDaatDialog chavatDaat={dialogData} closeDialog={toggleDialog}/>}
        </div>
    )
}

export default CustomeTnaimPanelAndTable